import React from "react";

const AboutIcon = ({ width = "800px", height = "800px", color = "#000000", onClick }) => (
    <svg
    width={width}
    height={height}
    viewBox="0 0 52 52"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}
    fill={color}
  >
    <rect
      height="6"
      rx="3"
      transform="translate(52 27.52) rotate(180)"
      width="6"
      x="23"
      y="10.76"
    />
    <path d="M27,41.24a2,2,0,0,1-2-2v-13H23a2,2,0,0,1,0-4h4a2,2,0,0,1,2,2v15A2,2,0,0,1,27,41.24Z" />
    <path d="M26,52A26,26,0,1,1,52,26,26,26,0,0,1,26,52ZM26,4A22,22,0,1,0,48,26,22,22,0,0,0,26,4Z" />
  </svg>
);


export default AboutIcon;
